import { ACCOUNTS_URL } from '@amlreputacional/accounts-ng-lib';
import { AE_ADMIN_URL } from '@amlreputacional/ae-admin-ng-lib';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import {
	GoogleLoginProvider,
	SocialAuthServiceConfig,
	SocialLoginModule
} from 'angularx-social-login';
import { NgxPermissionsModule } from 'ngx-permissions';
import { ConfirmationService, MessageService } from 'primeng/api';
import { MessageModule } from 'primeng/message';
import { MessagesModule } from 'primeng/messages';
import { StepsModule } from 'primeng/steps';
import { ToastModule } from 'primeng/toast';
import { PostInterceptor } from 'src/app/sistema/commons/interceptors/post.interceptor';
import { environment } from 'src/environments/environment';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { TokenInterceptor } from './auth/services/interceptors/token.interceptor';

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		AppRoutingModule,
		FormsModule,
		MessageModule,
		MessagesModule,
		ToastModule,
		HttpClientModule,
		BrowserAnimationsModule,
		SocialLoginModule,
		StepsModule,
		NgxPermissionsModule.forRoot(),
	],
	providers: [
		ConfirmationService,
		MessageService,
		{
			provide: 'SocialAuthServiceConfig',
			useValue: {
				autoLogin: true,
				providers: [
					{
						id: GoogleLoginProvider.PROVIDER_ID,
						provider: new GoogleLoginProvider(
							'855594575307-eiegck92p6tb3vu9qkua620fr0lv7ohu.apps.googleusercontent.com'
						),
					},
				],
			} as SocialAuthServiceConfig,
		},
		{
			provide: ACCOUNTS_URL,
			useValue: environment.baseAccountsUrl,
		},
		{
			provide: AE_ADMIN_URL,
			useValue: environment.baseEfetividadeUrl,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: TokenInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: PostInterceptor,
			multi: true,
		},
	],
	bootstrap: [AppComponent],
})
export class AppModule { }
